<template>
  <v-container class="py-12">
    <v-row

      justify="center"
    >
      <v-col
        xl="5"
        lg="6"
      >
        <div
          class="headline text-center font-weight-bold mb-4"
          style="color: #1c2244"
        >
          Central Yachts Management System
        </div>

        <v-card
          class="elevation-10 mt-6 radius-10"
        >
          <v-card-text class="pa-12">
            <form @submit.prevent="login">
              <v-text-field
                v-model="email"
                v-validate="'required'"
                outlined
                label="E-mail"
                name="email"
                data-vv-as="email"
                :error-messages="veeErrors.collect('email')"
              />
              <v-text-field
                v-model="password"
                v-validate="'required'"
                type="password"
                outlined
                label="Password"
                name="password"
                data-vv-as="password"
                :error-messages="veeErrors.collect('password')"
              />
              <v-btn
                block
                large
                type="submit"
                color="primary"
                class="ma-0"
                :loading="submitting"
              >
                <v-icon
                  left
                  small
                >
                  fa fa-sign-in-alt
                </v-icon>
                Login
              </v-btn>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Auth from '@/services/api/Auth'

export default {
    data() {
      return {
        email: null,
        password: null,
        submitting: false
      }
    },
    methods: {
      async login() {
        let validation = await this.$validator.validateAll()

        if (!validation) return

        this.submitting = true

        try {
          let data = await Auth.login(this.email, this.password)

          this.$store.dispatch('auth/login', data)

          let redirectModule = null

          if (this.$can('access-business')) redirectModule = 'business'
          if (this.$can('access-settings')) redirectModule = 'settings'
          if (this.$can('access-service')) redirectModule = 'service'

          this.$router.push({ path: redirectModule })
        } catch (e) {
          if (e.response && e.response.status === 422) {
            this.$store.dispatch('alert', {
              text: e.response.data.error ? e.response.data.error : e.response.data.message,
              color: 'error'
            })
            return
          }

          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
